import { createSlice } from "@reduxjs/toolkit";

const initalState = {
  selectedFeatures: [],
  selectedComponents: [],
  selectedSharedUid: null,
  selectedSite: null,
  designTemplatesData: [],
  siteOptions: [],
  selectedTemplateShareuid: null,
  page: 0,
  selectedTemplate: null,
};

const templateSlice = createSlice({
  name: "template",
  initialState: initalState,
  reducers: {
    setSelectedFeatures: (state, action) => {
      state.selectedFeatures = action.payload;
    },
    setSelectedComponents: (state, action) => {
      state.selectedComponents = action.payload;
    },
    setSelectedSite: (state, action) => {
      state.selectedSite = action.payload;
    },
    setSelectedSharedUid: (state, action) => {
      state.selectedSharedUid = action.payload;
    },
    setDesignTemplatesData: (state, action) => {
      state.designTemplatesData = action.payload;
    },
    setSiteOptions: (state, action) => {
      state.siteOptions = action.payload;
    },
    setSelectedTemplateShareuid: (state, action) => {
      state.selectedTemplateShareuid = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;
    },
  },
});

export const {
  setSelectedFeatures,
  setSelectedComponents,
  setSelectedSharedUid,
  setSelectedSite,
  setDesignTemplatesData,
  setSiteOptions,
  setSelectedTemplateShareuid,
  setPage,
  setSelectedTemplate,
} = templateSlice.actions;
export default templateSlice.reducer;
